import { useCallback, useEffect, useState } from "react"
import { exportToCSV, formatDate } from "utils/funcs"
import { useRouter } from "hooks/useRouter"
import { MetricCard } from "./BlackSparrow"
import { Loader } from "common/Loader"
import { Modal } from "common/Modal"
import { Table } from "common/Table/Table"
import swal from "sweetalert"
import UserService from "services/user.service"
import { useNotifications } from "hooks/useNotification"

const service = new UserService()

export const SpecificDealerAd = () => {
  const { params, push } = useRouter()

  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [data, setData] = useState<any>({
    total_ad: 0,
    total_spend: "0",
    total_applicant: "0",
    total_scheduled: "0",
    total_attendees: "0",
    adAmount: "",
    total_not_attendeed: "0",
    badge_id: "",
    state: "",
    city_name: "",
    notes: null,
    ad_type: "",
    ad_approval_status: "",
    ad_status: " ",
    season: " ",
    costPerCandidate: "",
    ad_amount: "",
    package_name: "",
    first_name: "",
    last_name: "",
    full_name: " ",
    total_contacted: "",
    who_is_paying_for_ad: "",
    meet_link: "",
    zipCode: "",
    totalSignedRep: "",
    package_start_date: "",
    package_end_date: "",
    total_follow_up: "",
    salesTypeOption: "",
    ad_run_day_count: 3,
  })
  const [tableData, setTableData] = useState([])
  const [collaborators, setCollaborators] = useState([])
  const [selectedRow, setSelectedRow] = useState<any>({
    collaboratorBadgeId: "",
    adId: params.id,
  })

  const { successMessage } = useNotifications()

  const columns = [
    { key: "first_name", dbColName: "first_name", title: "First Name" },
    { key: "last_name", dbColName: "last_name", title: "Last Name" },
    { key: "email", dbColName: "email", title: "Email" },
    {
      key: "phone",
      title: "Action",
      render: (row) => (
        <input
          type="checkbox"
          onClick={() =>
            setSelectedRow({ ...selectedRow, collaboratorBadgeId: row.badgeId })
          }
        />
      ),
    },
  ]

  const fetchCollaborators = useCallback(() => {
    service
      .getCollaborators(params.id)
      .then((resp) => {
        setCollaborators(resp.data.data)
      })
      .catch((err) => console.error(err))
  }, [params.id])

  useEffect(() => {
    setLoading(true)
    service
      .getDealerAdDetail(params.id)
      .then((resp) => {
        console.log(resp)
        setData(resp.data)
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false))

    fetchCollaborators()
  }, [params])

  if (loading) return <Loader />

  const handleExport = () => {
    exportToCSV(tableData, "list")
  }
  

  const handleCohostClick = () => {
    setShowModal(true)

    service
      .dealerTrainingsUsers(data?.data?.companyId)
      .then((resp) => {
        //   setTableData("collaborators")
        setTableData(resp.data.data)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const addCollaborator = () => {
    service
      .addCollaborator(selectedRow)
      .then((res) => {
        console.log(res)
        successMessage("Collaborator added successfully")
        setShowModal(false)
        fetchCollaborators()
        setSelectedRow({
          collaboratorBadgeId: "",
          adId: params.id,
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const deleteCollaborator = (badgeId) => {
    swal({
      title: "Are you sure, you want to delete this data?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .removeCollaborator({ adId: params.id, collaboratorBadgeId: badgeId })
          .then((res) => {
            successMessage("Collaborator deleted successfully")
            setCollaborators(
              collaborators.filter((c: any) => c.badgeId !== badgeId)
            )
          })
          .catch((err) => {
            console.error(err)
          })
      }
    })
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => push("/media-ads")}
            className="p-2 bg-white border rounded-md"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              />
            </svg>
          </button>
          <div>
            <h1 className="page-title">
              Dealer Ad Details
            </h1>
            <p className="page-subtitle">View details</p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleCohostClick}
          className="btn-dark"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 6v12m6-6H6"
            />
          </svg>
          Add co host
        </button>
      </div>
      <div className="flex flex-col gap-2 mb-5">
        {/* <p className="text-2xl font-semibold text-zinc-700">
          {data?.data?.city_name}, {data?.data?.state}
        </p> */}
        {/* <span className="leading-none text-green-600">
          {data?.data?.ad_status}
        </span> */}
      </div>
      <div className="grid grid-cols-4 gap-4">
        <MetricCard
          displayName="Total Spend"
          value={`$${data?.data?.adAmount}`}
        />
        <div
          className="cursor-pointer"
          onClick={() => {
            setShowModal(true)
          }}
        >
          <MetricCard
            displayName="Total Applicants"
            value={data?.total_applicant}
          />
        </div>
        {/* <MetricCard
            displayName="Cost Per Candidate"
            value={`$${data?.costPerCandidate ?? ""}`}
          />
          <MetricCard
            displayName="Total Shceduled"
            value={data?.total_scheduled}
          /> */}
        {/* <MetricCard
            displayName="Total Attendees"
            value={data?.total_attendees}
          />
        <div className="cursor-pointer" onClick={() => {setShowModal(true); setTableData('total_signed_rep_list')}}>
          <MetricCard
            displayName="Total Signedreps"
            value={data?.totalSignedRep}
          />
        </div>
        <div className="cursor-pointer" onClick={() => {setShowModal(true); setTableData('total_contacted_list')}}>
          <MetricCard
            displayName="Total Contacted"
            value={data?.total_contacted}
          />
        </div>
        <div className="cursor-pointer" onClick={() => {setShowModal(true); setTableData('total_follow_up_list')}}>
          <MetricCard
            displayName="Total Follow up"
            value={data?.total_follow_up}
          />
        </div> */}
      </div>
      <div className="flex items-start gap-4 mt-5">
        <div className="flex flex-col px-4 py-2 bg-white border divide-y rounded-lg shadow-sm md:w-1/4 border-zinc-200 divide-zinc-200">
          <div className="flex justify-between gap-4 py-3">
            <span>Creation Date</span>
            <span>{formatDate(data?.data?.createdAt)}</span>
          </div>
          {data?.data?.ad_type === "SALES" && (
            <div className="flex justify-between gap-4 py-3">
              <span className="whitespace-nowrap">Ad Objectives</span>
              <span className="text-right">{data?.data?.salesTypeOption}</span>
            </div>
          )}
          <div className="flex justify-between gap-4 py-3">
            <span>Campaign Name</span>
            <span className="break-all">{data?.data?.campaignName}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Campaign Type</span>
            <span className="break-all">{data?.data?.campaignType}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Ad Amount</span>
            <span className="break-all">{data?.data?.adAmount}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Payment Status</span>
            <span className="break-all">{data?.data?.payment}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Screening Level</span>
            <span className="break-all">{data?.data?.screeningLevel}</span>
          </div>

          <div className="flex justify-between gap-4 py-3">
            <span>Position Title</span>
            <span className="break-all">{data?.data?.epPositionTitle}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Job Description</span>
            <span className="break-all">{data?.data?.epJobDescription}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Benefits Offered</span>
            <span className="break-all">{data?.data?.epBenefitsOffered}</span>
          </div>




          <div className="flex justify-between gap-4 py-3">
            <span>Ad Type</span>
            <span>{data?.data?.isAiEnable ? "Scheduling" : "Screening"}</span>
          </div>
          <div className="flex justify-between gap-4 py-3">
            <span>Day Count</span>
            <span>{data?.data?.dayCount ?? 0}</span>
          </div>
          {data?.data?.meetLink && (
            <div className="flex justify-between gap-4 py-3">
              <span className="whitespace-nowrap">Meet Link</span>
              <span className="text-right">{data?.data?.meetLink}</span>
            </div>
          )}
        </div>
        <div className="flex-1 overflow-hidden bg-white rounded-lg shadow-sm">
          <h1 className="px-4 py-3 font-semibold border-b border-gray-200">
            Collaborators
          </h1>
          <Table
            totalItems={0}
            showPagination={false}
            exportButton={false}
            showSearch={false}
            handleExport={handleExport}
            columns={[
              { key: "badge_id", dbColName: "badgeId", title: "Badge ID" },
              {
                key: "first_name",
                dbColName: "first_name",
                title: "First Name",
              },
              { key: "last_name", dbColName: "last_name", title: "Last Name" },
              {
                key: "id",
                title: "Action",
                render: (row) => (
                  <button
                    type="button"
                    className="text-red-600"
                    onClick={() => deleteCollaborator(row.badgeId)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                      />
                    </svg>
                  </button>
                ),
              },
            ]}
            data={collaborators}
          />
        </div>
      </div>
      <Modal showModal={showModal} setShowModal={setShowModal} title="List">
        {selectedRow?.collaboratorBadgeId && (
          <button
            type="button"
            onClick={addCollaborator}
            className="bg-ink hover:bg-gray-800 absolute right-6 top-28 z-10 text-white rounded-lg p-2.5 text-sm flex gap-2 items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v12m6-6H6"
              />
            </svg>
            Add collaborator
          </button>
        )}
        <Table
          totalItems={0}
          showPagination={false}
          exportButton={false}
          showSearch={false}
          handleExport={handleExport}
          columns={columns}
          data={tableData}
        />
      </Modal>
    </div>
  )
}
